module.exports = __webpack_public_path__ + "img/andreea-retain-visitors.d62d1a9f.png";